import apiClient from "@/clients/apiClient";
import { ApiResponse } from "@/utils/ApiResponse";
import { ProductoFindOneInterface } from "../../interfaces/productoInterfaces/ProductoFindOne.interface";

export async function FinOneProductoAction (
    productoId: string
): Promise<ApiResponse<ProductoFindOneInterface>> {
   const {data} = await apiClient.get(`gpProductos/${productoId}`);
    return {
        status: 200,
        data,
        message: "Producto obtenida correctamente",
    };
}